"use client"

import { ChartColumnIncreasing } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ChartColumnIncreasingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ChartColumnIncreasingIcon = component(Icon)({
  as: ChartColumnIncreasing,
})
